import { render, staticRenderFns } from "./NodaApplePay.vue?vue&type=template&id=585abf07&scoped=true&"
import script from "./NodaApplePay.vue?vue&type=script&lang=js&"
export * from "./NodaApplePay.vue?vue&type=script&lang=js&"
import style0 from "./noda-button.scss?vue&type=style&index=0&id=585abf07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585abf07",
  null
  
)

export default component.exports